import tw from "twin.macro";

export const SectionHeading = tw.h2`text-2xl sm:text-4xl font-black tracking-wide text-center`
export const Subheading = tw.h4`font-bold font-black tracking-wide`
